import * as React from "react";
const SvgChartBar24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 22,
        height: 22,
        fill: "black",
        viewBox: "0 0 22 22"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M2 1V0H0v22h22v-2H2V1Zm11 1h7v15h-7V2Zm2 2v11h3V4h-3ZM5 8h7v9H5V8Zm2 2v5h3v-5H7Z",
      clipRule: "evenodd"
    })
  );
export default SvgChartBar24Px;
